/*

jvTooltip
============

Tooltip Usage 
=============
Requires:
_triangles.scss
_tooltip.scss

NOTE:
* Make sure you add {CLOSE} to the i18n in-page variables

Example Code:
<div tooltip class="tooltip inline-block">
    <div tooltip-trigger><i class="icon icon-help dark-sec"></i></div>
    <div tooltip-title>Help Text Title</div>
    <div tooltip-body>
        <p>
            Jobvite will check the availability of all rooms selected and
            attempt to find a single room for the entire interview.
        </p>
    </div>
</div>

* jv:tooltip directive is used to show help icon and on click of it showing the help text.
* The expression takes several params just like a normal function, comma-separated
    @param body {string}
    @param [title] {string} Optional title text
    @param [classes] {string} Optional additional classes to apply to the container
*/

angular.module('jv.Common.Directives.Tooltip', [])

.directive('tooltip2', ['$compile', 'addClick', 'addMouseover', 'bindAndUnbindClickToDocument',
           function($compile, addClick, addMouseover, docMagic) {
    return {
        replace: true,
        scope: true,
        compile: function(tEl, tAttr) {
            var _trigger = tEl.find('[tooltip-trigger]'), trigger = _trigger.html(),
                _title = tEl.find('[tooltip-title]'), _title_exists = (_title.length > 0), title = _title.html(),
                _body = tEl.find('[tooltip-body]'), body = _body.html();
            _trigger.remove();
            _title.remove();
            _body.remove();
            return {
                pre: function(scope, el, attr) {
                function tooltipAppear() {
                    scope.__showTooltip__ = true;
                }
                function tooltipDisappear() {
                    scope.__showTooltip__ = false;
                }
                function tooltipAppearWithApply() {
                    scope.$apply(tooltipAppear);
                }
                function tooltipDisappearWithApply() {
                    scope.$apply(tooltipDisappear);
                }

                var triggerHtml = angular.element(trigger);
                var tooltip = angular.element("<div class=\"tooltipWindow\" ng-show=\"__showTooltip__\"" + (attr.ngAnimate ? " ng-animate=\"" + attr.ngAnimate + "\"" : "") + "></div>");
                var tooltipContainer = angular.element("<div class=\"tooltipContainer\"></div>");
                var titleEl = angular.element("<div class=\"title\">" + title + "</div>");
                var bodyEl = angular.element("<div class=\"body\">" + body + "</div>");
                var setEvents = ((angular.isDefined(attr.$attr.showonhover) && attr.$attr.showonhover !== "false") ? addMouseover : addClick);


                if(angular.isDefined(attr.show)) {
                    scope.$watch(attr.show, function(newVal) {
                        if(newVal) {
                            docMagic(el, function() {
                                scope.$parent[attr.show] = false;
                                tooltipDisappearWithApply();
                            });
                            tooltipAppear();
                        }
                    });
                }

                scope.__showTooltip__ = false;
                el.append($compile(triggerHtml)(scope));
                if (_title_exists) {
                    tooltipContainer.append(titleEl);
                }
                tooltipContainer.append(bodyEl);
                tooltip.append(tooltipContainer);

                el.append($compile(tooltip)(scope));

                setEvents(el, tooltipAppearWithApply, tooltipDisappearWithApply);
            },
            post: angular.noop
            };
        }
    };
}]);
